module.exports = __webpack_public_path__ + "static/img/ad-8.5d9022f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-8.png
// module id = O8Cx
// module chunks = 0